import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";
import React from "react";
import Tooltipable from "~/components/effects/tooltipable";

const HelpTip = ({ label, children }) => (
  <Tooltipable trigger="click" placement="top" text={<>{children}</>}>
    <button
      type="button"
      className="btn btn-link btn-sm p-0 ml-1"
      aria-label={`Help for ${label}`}
    >
      <FontAwesomeIcon icon="far fa-info-circle" />
    </button>
  </Tooltipable>
);
HelpTip.propTypes = {
  label: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};
export default HelpTip;
